<template>
  <v-container fluid style="height: inherit; background-color: rgb(0 0 0 / 5%); overflow-y: auto;" class="pa-0">
    <v-row no-gutters class="pa-3">
      <v-col>
        <v-row no-gutters align="center">
          <v-col cols="0">
            <h3 v-text="'Next order'" />
            {{ formatCurrencyTotal(TotalAmountNextOrders) }}
          </v-col>
          <v-col cols="auto">
            <QDateField3 v-model="nextDate" :placeholder="$t('servicesystem.common_objects.commonterms.today')"
              externaledit clearable class="mt-n2">
            </QDateField3>
          </v-col>
          <v-col v-if="nextOrders.length > 0" cols="auto" class="ml-3 mt-1">
            <v-btn :color="generateLoading ? 'disabled' : 'primary'"
              :disabled="generateLoading || !HasLines || IsWorking" :loading="generateLoading" small
              @click="generateNextOrder">
              Generate order
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pa-3 pb-0" no-gutters align="center">
          <v-col cols="8">Contract</v-col>
          <v-col cols="3">TotalAmountExclVat</v-col>
          <v-col cols="1" class="d-flex justify-end">
            Details
          </v-col>
        </v-row>
        <div v-for="order in nextOrders" :key="order.Id">
          <NextOrderCard :order="order" />
        </div>
        <v-progress-linear v-if="loading" :indeterminate="!loading" height="1" color="secondary" class="my-1">
        </v-progress-linear>
        <v-divider v-else class="my-1"></v-divider>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import QDateField3 from "@/components/Inputs/QDateField3.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import NextOrderCard from './NextOrderCard.vue'

export default {
  name: 'ViewContractOrders',
  props: {},
  components: {
    QDateField3,
    NextOrderCard
  },
  mixins: [clientAPI],

  data() {
    return {
      initiated: false,
      isLoading: false,
      loading: false,
      nextLoading: false,
      pastLoading: false,
      generateLoading: false,
      valid: false,
      editMode: false,
      edittrigger: 1,
      nextOrders: [],
      nextDate: null,
    };
  },

  mounted() {
    this.fetch();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.ContractOrderEvent,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      // list of planIds that changed
      const planIds = args.paymentPlansId;
      const status = args.status;
      // find any plans with id inside nextOrders->Details->PaymentPlans->Id
      const affectedNextOrders = this.nextOrders.filter(no =>
        no.Details.some(d => d.PaymentPlans.some(pp => planIds.includes(pp.Id)))
      );
      if (affectedNextOrders) {
        affectedNextOrders.forEach(no => {
          no.Details.forEach(detail => {
            if (detail.PaymentPlans.some(pp => planIds.includes(pp.Id))) {
              detail.IsWorking = status === 1;
              detail.CreateOrder = status === 1;
            }
            if (args.orderId) {
              args.paymentPlanOrders.forEach(paymentOrder => {
                const paymentPlanMatch = detail.PaymentPlans.some(pp => pp.Id === paymentOrder.paymentPlanId);
                if (paymentPlanMatch) {
                  detail.IsLocked = true;
                  detail.OrderId = paymentOrder.paymentPlanOrderId;
                  detail.CreateOrder = false;
                }
              });
            }
          });
        });
      }
    },
    fetch() {
      this.isLoading = true;
      Promise.all([
        this.fetchNext(),
      ])
        .finally(() => {
          this.isLoading = false;
          this.initiated = true;
        });
    },

    fetchNext() {
      this.nextLoading = true;
      clientAPI.methods.getNextOrderContractsOverview(this.nextDate)
        .then((response) => {
          this.nextOrders = response.map(e => {
            //add vue observable prop flag to each detail
            // to monitor changes
            e.Details.forEach(d => {
              d.IsWorking = false;
              d.IsLocked = false;
              d.OrderId = null;
            });
            return e;
          });
        })
        .finally(() => {
          this.nextLoading = false;
        });
    },

    generateNextOrder() {
      clientAPI.methods.generateContractOrdersFromPaymentPlans(
        this.nextOrders
          .flatMap(no => no.Details)
          .filter(d => !(d.IsLocked || d.OrderId != null))
          .flatMap(d => d.PaymentPlans)
          .map(pp => pp.Id)
      );
    },
  },

  computed: {
    IsWorking() {
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .some(o => o.IsWorking);
    },
    HasLines() {
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .some(o => !(o.IsPaused || o.IsLocked));
    },
    TotalAmountNextOrders() {
      if (this.nextOrders == null || this.nextOrders.length === 0) {
        return 0;
      }
      return this.nextOrders
        .reduce((a, b) => a.concat(b.Details), [])
        .filter(o => !(o.IsLocked || o.OrderId != null))
        .map(o => o.OrderSum)
        .reduce((a, b) => a + b, 0);
    },
    contractId() {
      return this.$route.params.contractId;
    },

    // plain orders for chart (strip meta wrapper)
    pastOrdersPlain() {
      return (this.pastOrders || [])
        .map(m => m.Order)
        .filter(o => !!o);
    },
    // plain order for chart (strip meta wrapper)
    nextOrdersPlain() {
      return (this.nextOrders || [])
        .map(m => m.Order);
    },
  },

  watch: {
    contractId: function () {
      this.fetch();
    },

    nextDate: function () {
      this.fetchNext();
    }
  },
};
</script>
<style lang='scss' scoped>
.hidecaret.v-card--link:before {
  background: none;
  background-color: transparent;
}

.potentialorder {
  border: 1px dashed #9e9e9e !important;
  background-color: rgba(255, 255, 255, 0.641);
}
</style>